import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const PieChartStatistics = ({ siteList = [], queryList = [], chartLoader }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        width: 380,
        type: "pie",
      },
      labels: [],
      colors: [
        "#FF0000", // Dark red
        "#FF3333", // Medium-dark red
        "#FF6666", // Medium red
        "#FF9999", // Light red
        "#FFCCCC"  // Very light red
      ],
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
    if (siteList.length > 0 && queryList.length > 0) {
      setChartData((prevState) => ({
        ...prevState,
        series: queryList,
        options: {
          ...prevState.options,
          labels: siteList,
        },
      }));
    }
  }, [siteList, queryList]);

  return (
    <div className="p-2">
      <h5 className="fw-bold mb-1 text-center w-100 mt-2">Query Chart</h5>
      {chartLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
        chartData.series.length > 0 && (
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="pie"
            width={380}
          />
        )}
    </div>
  );
};

export default PieChartStatistics;